import { createLucideIcon } from './lucideIcon'

export const MoreVertical = createLucideIcon(
  'MoreVertical',
  <>
    <circle cx="12" cy="12" r="1" />
    <circle cx="12" cy="5" r="1" />
    <circle cx="12" cy="19" r="1" />
  </>
)
